import React, { createElement, type FunctionComponent, lazy, Suspense } from 'react';
import { Route, Routes } from 'react-router-dom';
import Routing from '../../routing/routing';

interface IContentSwitchProps {
  homeComponent: FunctionComponent;
}

const ContentSwitch: FunctionComponent<IContentSwitchProps> = ({ homeComponent }) => {
  const LazyMembershipPage = lazy(() => import('../../pages/MembershipPage/MembershipPage'));
  const LazyCoursesPage = lazy(() => import('../../pages/CoursePage/CoursePage'));
  const LazyMyDistrictPage = lazy(() => import('../../pages/myDistrictPage/myDistrictPage'));
  const LazyMySchoolPage = lazy(() => import('../../pages/MySchoolPage/MySchoolPage'));
  const LazyMessagePage = lazy(() => import('../../pages/MessagePage/MessagePage'));
  const LazyCasesPage = lazy(() => import('../../pages/MyCasesPage/MyCasesPage'));
  const LazyNewMessagePage = lazy(() => import('../../pages/NewMessagePage/NewMessagePage'));

  return (
    <Suspense fallback="">
      <Routes>
        <Route path="/" element={createElement(homeComponent)} />
        <Route path={Routing.membership} element={<LazyMembershipPage />} />
        <Route path={Routing.courses} element={<LazyCoursesPage />} />
        <Route path={Routing.district} element={<LazyMyDistrictPage />} />
        <Route path={Routing.school} element={<LazyMySchoolPage />} />
        <Route path={Routing.messages} element={<LazyMessagePage />} />
        <Route path={`${Routing.reply}/:id?`} element={<LazyNewMessagePage />} />
        <Route path={`${Routing.newMessage}/:id?`} element={<LazyNewMessagePage />} />
        <Route path={Routing.cases} element={<LazyCasesPage />} />
      </Routes>
    </Suspense>
  );
};

export default ContentSwitch;
